import { SERVICE_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import ObjectDefinitionRecord from '../ObjectDefinitionRecord';
const Service = ObjectDefinitionRecord({
  enableAsAssociatedType: true,
  hasAccess: (_isUngated, hasScope) => hasScope('services-object-access'),
  objectTypeId: SERVICE_TYPE_ID,
  referenceObjectType: 'SERVICE_PROPERTIES'
});
export default Service;